// import React from "react";
// import { NavLink } from "react-router-dom";
// import { getPermissions } from "../../../utils/permissions";
// import {
//   DashboardIcon,
//   UsersIcon,
//   RegisterIcon,
//   StudentsIcon,
//   EditIcon,
//   DeleteIcon,
//   ViewIcon,
//   FeeIcon,
//   LogoutIcon,
//   PromoteIcon,
//   CalendarIcon,
//   GradeIcon,
//   ReportIcon,
//   UserIcon,
//   CampusIcon,
// } from "../icons/Icons";

// const ROLE_LABELS = {
//   superadmin: "Superadmin User",
//   admin: "Admin User",
//   controller: "Controller",
//   viewer: "Viewer",
//   teacher: "Teacher",
// };

// function Sidebar({ loginRole, sidebarOpen, onLogout }) {
//   const navItemClass = ({ isActive }) => `nav-item ${isActive ? "active" : ""}`;

//   const isSuperadmin = loginRole === "superadmin";
//   const isAdmin = loginRole === "admin";
//   const isController = loginRole === "controller";
//   const isTeacher = loginRole === "teacher";
//   const permissions = getPermissions(loginRole);

//   const showStudentManagement =
//     permissions.canViewStudents ||
//     permissions.canRegisterStudents ||
//     permissions.canDeleteStudents;

//   const canRegisterTeachers =
//     permissions.canRegisterTeachers ?? (isSuperadmin || isAdmin);

//   const canAssignCourses = permissions.canAssignCourses ?? canRegisterTeachers;

//   const showTeacherManagement = canRegisterTeachers || canAssignCourses;

//   return (
//     <aside className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>
//       <div className="sidebar-header">
//         <img
//           src={process.env.PUBLIC_URL + "/als-logo.png"}
//           alt="ALS"
//           className="sidebar-logo"
//         />
//         <div className="sidebar-brand">
//           {/* Optional: show role text using ROLE_LABELS[loginRole] */}
//         </div>
//       </div>

//       <nav className="sidebar-nav">
//         <div className="nav-section-title">Main</div>

//         <NavLink to="/dashboard" className={navItemClass}>
//           <DashboardIcon />
//           Dashboard
//         </NavLink>

//         {/* Teacher-specific menu items */}
//         {isTeacher && (
//           <>
//             <div className="nav-section-title">Teacher Portal</div>

//             <NavLink to="/teacher/timetable" className={navItemClass}>
//               <CalendarIcon />
//               My Timetable
//             </NavLink>

//             {permissions.canViewAssignedStudents && (
//               <NavLink to="/teacher/students" className={navItemClass}>
//                 <StudentsIcon />
//                 My Students
//               </NavLink>
//             )}

//             {permissions.canManageGrades && (
//               <NavLink to="/teacher/grades" className={navItemClass}>
//                 <GradeIcon />
//                 Manage Grades
//               </NavLink>
//             )}

//             {permissions.canViewTeacherReports && (
//               <NavLink to="/teacher/reports" className={navItemClass}>
//                 <ReportIcon />
//                 Reports
//               </NavLink>
//             )}

//             <NavLink to="/teacher/campus" className={navItemClass}>
//               <CampusIcon />
//               Campus Info
//             </NavLink>

//             <NavLink to="/teacher/profile" className={navItemClass}>
//               <UserIcon />
//               Profile
//             </NavLink>
//           </>
//         )}

//         {(isSuperadmin || isAdmin) && (
//           <>
//             <div className="nav-section-title">Administration</div>

//             <NavLink to="/superadmin/campuses" className={navItemClass}>
//               <DashboardIcon />
//               Campus Management
//             </NavLink>

//             {isSuperadmin && (
//               <NavLink to="/superadmin/admins" className={navItemClass}>
//                 <UsersIcon />
//                 Admin Management
//               </NavLink>
//             )}
//           </>
//         )}

//         {permissions.canViewAcademicReports && !isTeacher && (
//           <>
//             <div className="nav-section-title">Reports</div>

//             <NavLink
//               to={
//                 isController
//                   ? "/controller/school-reports"
//                   : "/admin/school-reports"
//               }
//               className={navItemClass}
//             >
//               <ViewIcon />
//               School Reports
//             </NavLink>

//             <NavLink
//               to={
//                 isController
//                   ? "/controller/student-reports"
//                   : "/admin/student-reports"
//               }
//               className={navItemClass}
//             >
//               <StudentsIcon />
//               Student Reports
//             </NavLink>

//             <NavLink
//               to={isController ? "/controller/passed-out" : "/admin/passed-out"}
//               className={navItemClass}
//             >
//               <PromoteIcon />
//               Passed Out Students
//             </NavLink>
//           </>
//         )}

//         {showStudentManagement && !isTeacher && (
//           <>
//             <div className="nav-section-title">Student Management</div>

//             {permissions.canRegisterStudents && (
//               <NavLink to="/students/register" className={navItemClass}>
//                 <RegisterIcon />
//                 Add Student
//               </NavLink>
//             )}

//             {permissions.canViewStudents && (
//               <NavLink to="/students/manage" className={navItemClass}>
//                 <EditIcon />
//                 Record Management
//               </NavLink>
//             )}

//             {permissions.canDeleteStudents && (
//               <NavLink to="/students/bulk-delete" className={navItemClass}>
//                 <DeleteIcon />
//                 Bulk Delete
//               </NavLink>
//             )}
//           </>
//         )}

//         {showTeacherManagement && !isTeacher && (
//           <>
//             <div className="nav-section-title">Teacher Management</div>

//             {/* {canRegisterTeachers && (
//               <NavLink to="/teachers/register" className={navItemClass}>
//                 <RegisterIcon />
//                 Add Teacher
//               </NavLink>
//             )} */}

//             {canRegisterTeachers && (
//               <NavLink to="/teachers/reports" className={navItemClass}>
//                 <ViewIcon />
//                 Teacher
//               </NavLink>
//             )}

//             {canAssignCourses && (
//               <NavLink to="/teachers/courses" className={navItemClass}>
//                 <RegisterIcon />
//                 Course
//               </NavLink>
//             )}

//             {canAssignCourses && (
//               <NavLink to="/teachers/timetable" className={navItemClass}>
//                 <ViewIcon />
//                 Timetable
//               </NavLink>
//             )}

//             {canAssignCourses && (
//               <NavLink to="/teachers/view-timetable" className={navItemClass}>
//                 <ViewIcon />
//                 View Timetable
//               </NavLink>
//             )}
//           </>
//         )}

//         {!isTeacher && (
//           <>
//             <div className="nav-section-title">Analysis & Reports</div>

//             {permissions.canViewFees && (
//               <NavLink to="/fees" className={navItemClass}>
//                 <FeeIcon />
//                 Fee Management
//               </NavLink>
//             )}

//             {isSuperadmin && (
//               <NavLink to="/superadmin/reports" className={navItemClass}>
//                 <ViewIcon />
//                 System Reports
//               </NavLink>
//             )}

//             {isController && (
//               <>
//                 <NavLink
//                   to="/controller/system-reports"
//                   className={navItemClass}
//                 >
//                   <ViewIcon />
//                   System Reports
//                 </NavLink>

//                 <NavLink
//                   to="/controller/campus-analytics"
//                   className={navItemClass}
//                 >
//                   <DashboardIcon />
//                   Campus Analytics
//                 </NavLink>
//               </>
//             )}

//             {permissions.isViewer && (
//               <NavLink to="/viewer/campus-analytics" className={navItemClass}>
//                 <ViewIcon />
//                 Campus Analytics
//               </NavLink>
//             )}
//           </>
//         )}
//       </nav>
//     </aside>
//   );
// }

// export default Sidebar;

import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FiUser } from "react-icons/fi";
import { MdDescription, MdAssignment } from "react-icons/md";
import { getPermissions } from "../../../utils/permissions";
import { API_BASE_URL, getAuthHeaders } from "../../../utils/api";
import {
  countUnreadParentNotifications,
  filterVisibleParentNotifications,
  PARENT_NOTIFICATIONS_EVENT,
} from "../../../utils/parentNotifications";
import {
  DashboardIcon,
  UsersIcon,
  RegisterIcon,
  StudentsIcon,
  EditIcon,
  DeleteIcon,
  ViewIcon,
  FeeIcon,
  LogoutIcon,
  PromoteIcon,
  CalendarIcon,
  GradeIcon,
  ReportIcon,
  CampusIcon,
  BookIcon,
} from "../icons/Icons";

const ROLE_LABELS = {
  superadmin: "Superadmin User",
  principal: "Campus Principal",
  administrator: "Campus Administrator",
  accountant: "Campus Accountant",
  admin: "Admin User",
  viewer: "Viewer",
  teacher: "Teacher",
  parent: "Parent",
};

function Sidebar({ loginRole, sidebarOpen, onLogout }) {
  const navItemClass = ({ isActive }) => `nav-item ${isActive ? "active" : ""}`;
  const role = (loginRole || "").toLowerCase();

  const isSuperadmin = role === "superadmin";
  const isPrincipal = role === "principal";
  const isAdministrator = role === "administrator";
  const isAdmin = role === "admin";
  const isTeacher = role === "teacher";
  const isParent = role === "parent";
  const permissions = getPermissions(role);
  const [campusLabel, setCampusLabel] = useState("");
  const [notifUnread, setNotifUnread] = useState(0);

  useEffect(() => {
    if (!isParent) {
      setNotifUnread(0);
      return undefined;
    }

    let cancelled = false;
    const refreshUnread = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/parents/me/notifications`, {
          headers: getAuthHeaders(),
        });
        if (!res.ok) return;
        const data = await res.json();
        const items = filterVisibleParentNotifications(
          Array.isArray(data.items) ? data.items : [],
        );
        if (!cancelled) setNotifUnread(countUnreadParentNotifications(items));
      } catch (err) {
        console.error("Failed to load parent notification count", err);
      }
    };

    refreshUnread();
    const onUpdate = () => refreshUnread();
    window.addEventListener(PARENT_NOTIFICATIONS_EVENT, onUpdate);
    window.addEventListener("storage", onUpdate);
    const timer = window.setInterval(refreshUnread, 60000);
    return () => {
      cancelled = true;
      window.removeEventListener(PARENT_NOTIFICATIONS_EVENT, onUpdate);
      window.removeEventListener("storage", onUpdate);
      window.clearInterval(timer);
    };
  }, [isParent]);

  useEffect(() => {
    if (
      role !== "accountant" &&
      role !== "principal" &&
      role !== "administrator" &&
      role !== "admin"
    ) {
      setCampusLabel("");
      return undefined;
    }

    let cancelled = false;
    const loadCampusName = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/campuses`, {
          headers: getAuthHeaders(),
        });
        if (!res.ok) return;
        const data = await res.json();
        if (cancelled || !Array.isArray(data) || data.length === 0) return;
        const names = data.map((campus) => campus.name).filter(Boolean);
        setCampusLabel(names.join(", "));
      } catch (err) {
        console.error("Failed to load campus name for sidebar", err);
      }
    };

    loadCampusName();
    return () => {
      cancelled = true;
    };
  }, [role]);

  const showCampusName =
    (role === "accountant" || role === "administrator" || role === "principal" || role === "admin") && campusLabel;
  const roleChipTitle = showCampusName
    ? campusLabel
    : ROLE_LABELS[role] || "School User";
  const roleChipInitials = (showCampusName ? campusLabel : role || "user")
    .slice(0, 2)
    .toUpperCase();

  const showStudentManagement =
    permissions.canViewStudents ||
    permissions.canRegisterStudents ||
    permissions.canDeleteStudents;

  const canRegisterTeachers =
    permissions.canRegisterTeachers ?? (isSuperadmin || isPrincipal || isAdministrator || isAdmin);

  const canAssignCourses = permissions.canAssignCourses ?? canRegisterTeachers;
  const canViewTeachers = permissions.canViewTeachers ?? canRegisterTeachers;
  const canViewTeacherAssignments =
    permissions.canViewTeacherAssignments ?? canAssignCourses;
  const canViewTeacherTimetable =
    permissions.canViewTeacherTimetable ?? canAssignCourses;

  const showTeacherManagement =
    canViewTeachers || canViewTeacherAssignments || canViewTeacherTimetable;

  const showAnalysisReports =
    isSuperadmin || isAdmin || permissions.isViewer;

  const showCampusAdministration =
    permissions.canManageCampuses || isSuperadmin || isPrincipal || isAdministrator || isAdmin;

  return (
    <aside className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>
      <div className="sidebar-header">
        <img
          src={process.env.PUBLIC_URL + "/als-logo.png"}
          alt="ALS"
          className="sidebar-logo"
        />
        <div className="sidebar-brand">
          <strong>American Lycetuff</strong>
          <span>
            {showCampusName
              ? campusLabel
              : ROLE_LABELS[role] || "School Portal"}
          </span>
        </div>
      </div>

      <nav className="sidebar-nav">
        <div className="nav-section-title">Main</div>

        <NavLink
          to={
            isTeacher
              ? "/teacher/overview"
              : isParent
                ? "/parent/overview"
                : "/dashboard"
          }
          end
          className={navItemClass}
        >
          <DashboardIcon />
          Dashboard
        </NavLink>

        {/* Teacher-specific menu items */}
        {isTeacher && (
          <>
            <div className="nav-section-title">Teacher Portal</div>

            <NavLink to="/teacher/courses" className={navItemClass}>
              <BookIcon />
              Courses
            </NavLink>

            <NavLink to="/teacher/timetable" className={navItemClass}>
              <CalendarIcon />
              Timetable
            </NavLink>

            {permissions.canViewAssignedStudents && (
              <NavLink to="/teacher/students" className={navItemClass}>
                <StudentsIcon />
                Students
              </NavLink>
            )}

            {permissions.canManageGrades && (
              <NavLink to="/teacher/grades" className={navItemClass}>
                <GradeIcon />
                Manage Grades
              </NavLink>
            )}

            <NavLink to="/teacher/calendar" className={navItemClass}>
              <CalendarIcon />
              Yearly Calendar
            </NavLink>

            {permissions.canViewTeacherReports && (
              <NavLink to="/teacher/reports" className={navItemClass}>
                <ReportIcon />
                Reports
              </NavLink>
            )}

            <NavLink to="/teacher/campus" className={navItemClass}>
              <CampusIcon />
              Campus Info
            </NavLink>

            <NavLink to="/teacher/profile" className={navItemClass}>
              <FiUser size={18} />
              Profile
            </NavLink>
          </>
        )}

        {isParent && (
          <>
            <div className="nav-section-title">Parent Portal</div>
            <NavLink to="/parent/select-child" className={navItemClass}>
              <StudentsIcon />
              My Children
            </NavLink>
            <NavLink to="/parent/analytics" className={navItemClass}>
              <ReportIcon />
              Analytics
            </NavLink>
            <NavLink to="/parent/calendar" className={navItemClass}>
              <CalendarIcon />
              Yearly Calendar
            </NavLink>
            <NavLink to="/parent/timetable" className={navItemClass}>
              <CalendarIcon />
              Timetable
            </NavLink>
            <NavLink to="/parent/fees" className={navItemClass}>
              <FeeIcon />
              Fees
            </NavLink>
            <NavLink to="/parent/notifications" className={navItemClass}>
              <ReportIcon />
              <span className="nav-item-label">
                Notifications
                {notifUnread > 0 ? (
                  <span className="nav-badge" aria-label={`${notifUnread} unread`}>
                    {notifUnread > 99 ? "99+" : notifUnread}
                  </span>
                ) : null}
              </span>
            </NavLink>
            <NavLink to="/parent/profile" className={navItemClass}>
              <FiUser size={18} />
              Profile
            </NavLink>
          </>
        )}

        {showCampusAdministration && !isParent && (
          <>
            <div className="nav-section-title">Administration</div>

            <NavLink to="/superadmin/campuses" className={navItemClass}>
              <DashboardIcon />
              Campus Management
            </NavLink>

            {isSuperadmin && (
              <NavLink to="/superadmin/admins" className={navItemClass}>
                <UsersIcon />
                Admin Management
              </NavLink>
            )}
          </>
        )}

        {!isTeacher && !isParent && permissions.canViewFees && (
          <>
            <div className="nav-section-title">Fee Management</div>

            <NavLink to="/fees" className={navItemClass}>
              <FeeIcon />
              Fee Management
            </NavLink>
          </>
        )}

        {!isTeacher && !isParent && permissions.canViewCalendar && (
          <>
            <div className="nav-section-title">Academics</div>
            <NavLink to="/calendar" className={navItemClass}>
              <CalendarIcon />
              Yearly Calendar
            </NavLink>
          </>
        )}

        {permissions.canViewAcademicReports && !isTeacher && !isParent && (
          <>
            <div className="nav-section-title">Reports</div>

            <NavLink
              to={
                isAdmin
                  ? "/admin/school-reports"
                  : "/principal/school-reports"
              }
              className={navItemClass}
            >
              <ViewIcon />
              School Reports
            </NavLink>

            <NavLink
              to={
                isAdmin
                  ? "/admin/student-reports"
                  : "/principal/student-reports"
              }
              className={navItemClass}
            >
              <StudentsIcon />
              Student Reports
            </NavLink>

            <NavLink
              to={isAdmin ? "/admin/passed-out" : "/principal/passed-out"}
              className={navItemClass}
            >
              <PromoteIcon />
              Passed Out Students
            </NavLink>
          </>
        )}

        {showStudentManagement && !isTeacher && !isParent && (
          <>
            <div className="nav-section-title">Student Management</div>

            {permissions.canRegisterStudents && (
              <NavLink to="/students/register" className={navItemClass}>
                <RegisterIcon />
                Add Student
              </NavLink>
            )}

            {permissions.canViewStudents && (
              <NavLink to="/students/manage" className={navItemClass}>
                <EditIcon />
                Record Management
              </NavLink>
            )}

            {permissions.canDeleteStudents && (
              <NavLink to="/students/bulk-delete" className={navItemClass}>
                <DeleteIcon />
                Bulk Delete
              </NavLink>
            )}
          </>
        )}

        {showTeacherManagement && !isTeacher && !isParent && (
          <>
            <div className="nav-section-title">Teacher Management</div>

            {/* {canRegisterTeachers && (
              <NavLink to="/teachers/register" className={navItemClass}>
                <RegisterIcon />
                Add Teacher
              </NavLink>
            )} */}

            {canViewTeachers && (
              <NavLink to="/teachers/reports" className={navItemClass}>
                <ViewIcon />
                Teacher
              </NavLink>
            )}

            {canViewTeacherAssignments && (
              <NavLink to="/teachers/courses" className={navItemClass}>
                <RegisterIcon />
                {isAdmin ? "Teacher Courses & Classes" : "Course"}
              </NavLink>
            )}

            {canAssignCourses && (
              <NavLink to="/teachers/timetable" className={navItemClass}>
                <ViewIcon />
                Timetable
              </NavLink>
            )}

            {canViewTeacherTimetable && (
              <NavLink to="/teachers/view-timetable" className={navItemClass}>
                <ViewIcon />
                View Timetable
              </NavLink>
            )}
          </>
        )}

        {!isTeacher && !isParent && showAnalysisReports && (
          <>
            <div className="nav-section-title">Analysis & Reports</div>

            {isSuperadmin && (
              <NavLink to="/superadmin/reports" className={navItemClass}>
                <ViewIcon />
                System Reports
              </NavLink>
            )}

            {isAdmin && (
              <>
                <NavLink
                  to="/admin/system-reports"
                  className={navItemClass}
                >
                  <ViewIcon />
                  System Reports
                </NavLink>

                <NavLink
                  to="/admin/campus-analytics"
                  className={navItemClass}
                >
                  <DashboardIcon />
                  Campus Analytics
                </NavLink>
              </>
            )}

            {permissions.isViewer && (
              <NavLink to="/viewer/campus-analytics" className={navItemClass}>
                <ViewIcon />
                Campus Analytics
              </NavLink>
            )}
          </>
        )}

        {/* ── Other ── visible to teacher, admin, principal, superadmin (not parent) ── */}
        {!isParent && (role === "teacher" || isSuperadmin || isPrincipal || isAdmin || isAdministrator) && (
          <>
            <div className="nav-section-title">Other</div>

            {/* Procurement Filing — teacher, admin, administrator, principal can file;
                superadmin can view all requests */}
            <NavLink to="/procurement" className={navItemClass}>
              <MdDescription size={18} />
              Procurement Filing
            </NavLink>

            {/* Daily Report — admin/principal submit; superadmin views all campuses */}
            {(isPrincipal || isAdmin || isAdministrator || isSuperadmin) && (
              <NavLink
                to={isSuperadmin ? "/daily-report/overview" : "/daily-report"}
                className={navItemClass}
              >
                <MdAssignment size={18} />
                Daily Report
              </NavLink>
            )}
          </>
        )}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-role-chip">
          <span>{roleChipInitials}</span>
          <div>
            <strong title={roleChipTitle}>{roleChipTitle}</strong>
            <small>Signed in</small>
          </div>
        </div>
        <button type="button" className="logout-btn" onClick={onLogout}>
          <LogoutIcon />
          <span>Sign Out</span>
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
